module.exports = __webpack_public_path__ + "static/ron.644ac474.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/ron.png
// module id = 574
// module chunks = 263791100135453